/* global axios */
import ApiClient from './ApiClient';

class CommissionLedgerAPI extends ApiClient {
  constructor() {
    super('commissions', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CommissionLedgerAPI();
